import { COLORS } from '@btime/constants'
import { useCheckinHandlerResult, useCheckinService } from '../ServiceContext'

// OBS to Reviewer - this message is good enough?
const MESSAGE_EVENTS = {
  error: {
    icon: 'RiCloseCircleLine',
    title: 'Ocorreu Algum erro ao salvar uma nova integração!',
    subtitle: 'Tente novamente em alguns segundos, se erro persistir entre em contato pelo chat!',
    colorIcon: COLORS.red
  },
  success: {
    icon: 'RiCheckboxCircleLine',
    title: 'Nova integração criada com sucesso!',
    subtitle: 'Essa aba já pode ser fechada!',
    colorIcon: COLORS.green
  },
  loading: {}
}

const useServiceEventMessages = () => {
  const [handlerResult] = useCheckinHandlerResult()
  if (!handlerResult) return {}

  return MESSAGE_EVENTS[handlerResult]
}

export default useServiceEventMessages
